import { Box, Flex } from "@chakra-ui/react"
import React from "react"
import { useActionsDrawerContext } from "./ActionsDrawerContextProvider"
import { BoostingPanel } from "./BoostingPanel"
import { OnboardingPanel } from "./OnboardingPanel"

type Props = {
  isDrawer?: boolean
}

export const ActionsDrawer: React.FC<Props> = ({ isDrawer }) => {
  const { showDrawer, currentPhase } = useActionsDrawerContext()

  if (!showDrawer) return null

  return (
    <Box h="full">
      <Flex
        h="full"
        bg="ds.background.neutral.resting"
        rounded={isDrawer ? "0px" : "16px"}
        flexDirection="column"
        gap={6}
        pt={6}
        pb={2}
      >
        <Flex flexDirection="column" gap={6} px={3} alignItems="flex-start">
          {currentPhase === "onboarding" && <OnboardingPanel />}

          {currentPhase === "boosting" && <BoostingPanel />}
        </Flex>
      </Flex>
    </Box>
  )
}
